<template lang="">
    <Icon class="cursor-pointer" @click="downloadZip(fileNames)" name="Baixar"/>
</template>
<script>
import JSZip from "jszip";
import download from 'downloadjs';
import Icon from "@/Components/UI/Icons/Icon.vue";

export default {
    components: {
        Icon
    },
    props: {
        zipName: String,
        fileNames: Object,
    },
    methods: {
        async downloadZip(fileNames) {
            try { 
                var zip = new JSZip();

                await Promise.all(fileNames.map(async fileName => {
    
                    const {data} = await axios.get('/download', {
                        headers: this.headers,
                        responseType: 'blob',
                        params: {
                            imageUrl: fileName,
                        },
                    })

                    zip.file(fileName, data);
                }));

                const zipFile = await zip.generateAsync({type:"blob"});
                const zipName = this.zipName || "galeria";

                download(zipFile, zipName, 'application/zip');
            } catch(err) {
                console.log(err);
            }
        },
    }
}
</script>